import { createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";
import { PlanTypes } from "./plan-actions";

export const INITIAL_STATE = Immutable({
    creating: false,
    plan: null,
    errorCreating: null,
    updating: false,
    errorUpdating: null,
    addingWatchersToPlan: false,
    addedWatchersToPlan: null,
    addingWatchersToPlanError: null,
    removingWatcherFromPlan: false,
    removedWatcherFromPlan: null,
    removingWatcherFromPlanError: null,
    fetchingWatchers: false,
    watchers: null,
    watchersError: null,
});

export const createRequest = (state) => {
    return { ...state, creating: true, plan: null, errorCreating: null };
};

export const createSuccess = (state, action) => {
    const { plan } = action;
    return { ...state, creating: false, errorCreating: null, plan };
};

export const createFailure = (state, action) => {
    const { error } = action;
    return { ...state, creating: false, errorCreating: error, plan: null };
};

export const updateRequest = (state) => {
    return { ...state, updating: true, errorUpdating: null };
};

export const updateSuccess = (state, action) => {
    const { plan } = action;
    return { ...state, updating: false, errorUpdating: null, plan };
};

export const updateFailure = (state, action) => {
    const { error } = action;
    return { ...state, updating: false, errorUpdating: error };
};

export const addWatchersRequest = (state) => {
    return { ...state, addingWatchersToPlan: true, addedWatchersToPlan: null, addingWatchersToPlanError: null };
};

export const addWatchersSuccess = (state, action) => {
    const { watcherContent } = action;
    return { ...state, addingWatchersToPlan: false, addedWatchersToPlan: watcherContent, addingWatchersToPlanError: null };
};

export const addWatchersFailure = (state, action) => {
    const { error } = action;
    return { ...state, addingWatchersToPlan: false, addedWatchersToPlan: null, addingWatchersToPlanError: error };
};

export const removeWatcherRequest = (state) => {
    return { ...state, removingWatcherFromPlan: true, removedWatcherFromPlan: null, removingWatcherFromPlanError: null };
};

export const removeWatcherSuccess = (state) => {
    return { ...state, removingWatcherFromPlan: false, removedWatcherFromPlan: true, removingWatcherFromPlanError: null };
};

export const removeWatcherFailure = (state, action) => {
    const { error } = action;
    return { ...state, removingWatcherFromPlan: false, removedWatcherFromPlan: null, removingWatcherFromPlanError: error };
};

export const watchersRequest = (state) => {
    return { ...state, fetchingWatchers: true, watchers: null, watchersError: null };
};

export const watchersSuccess = (state, action) => {
    const { watchers } = action;
    return { ...state, fetchingWatchers: false, watchers, watchersError: null };
};

export const watchersFailure = (state, action) => {
    const { error } = action;
    return { ...state, fetchingWatchers: false, watchers: null, watchersError: error };
};

export const reducer = createReducer(INITIAL_STATE, {
    [PlanTypes.PLAN_CREATE_REQUEST]: createRequest,
    [PlanTypes.PLAN_CREATE_SUCCESS]: createSuccess,
    [PlanTypes.PLAN_CREATE_FAILURE]: createFailure,
    [PlanTypes.PLAN_UPDATE_REQUEST]: updateRequest,
    [PlanTypes.PLAN_UPDATE_SUCCESS]: updateSuccess,
    [PlanTypes.PLAN_UPDATE_FAILURE]: updateFailure,
    [PlanTypes.PLAN_ADD_WATCHERS_REQUEST]: addWatchersRequest,
    [PlanTypes.PLAN_ADD_WATCHERS_SUCCESS]: addWatchersSuccess,
    [PlanTypes.PLAN_ADD_WATCHERS_FAILURE]: addWatchersFailure,
    [PlanTypes.PLAN_REMOVE_WATCHER_REQUEST]: removeWatcherRequest,
    [PlanTypes.PLAN_REMOVE_WATCHER_SUCCESS]: removeWatcherSuccess,
    [PlanTypes.PLAN_REMOVE_WATCHER_FAILURE]: removeWatcherFailure,
    [PlanTypes.PLAN_ALL_WATCHERS_REQUEST]: watchersRequest,
    [PlanTypes.PLAN_ALL_WATCHERS_SUCCESS]: watchersSuccess,
    [PlanTypes.PLAN_ALL_WATCHERS_FAILURE]: watchersFailure,
});
